import { useNavigate } from 'react-router-dom';

import logo from '../../assets/reshet.png';
import { Box } from '@mui/material';
import Zoom from '@mui/material/Zoom';
import { keyframes } from '@emotion/react';
import AuthLayout from '../../layouts/AuthLayout';

const Intro = () => {
  const navigate = useNavigate();

  const myKeyframe = keyframes`
    0%  { filter:blur(0.2px);opacity:1  }
    45% { filter:blur(0.3px) }
    85% { filter:blur(0px)  }
    90% { opacity:1  }
    100% { opacity:0  }
    100% { filter:blur(0px)  }
`;

  return (
    <AuthLayout>
      <Box>
        <Zoom
          onAnimationEndCapture={() => navigate('/login')}
          in={true}
          style={{ transitionDuration: '5s', opacity: 0 }}
        >
          <Box
            component="img"
            sx={{
              animation: `${myKeyframe} 5.1s`,

              height: {
                xs: '15vh',
                sm: '20vh',
                md: '25vh'
              }
            }}
            alt="logo."
            src={logo}
          />
        </Zoom>
      </Box>
    </AuthLayout>
  );
};

export default Intro;
